/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Premium_Voices_SubInputs */

const en_dialog_premium_voices_sub = /** @type {(inputs: Dialog_Premium_Voices_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free is limited to 2 options`)
};

const es_dialog_premium_voices_sub = /** @type {(inputs: Dialog_Premium_Voices_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis limitado a 2 opciones`)
};

/**
* | output |
* | --- |
* | "Free is limited to 2 options" |
*
* @param {Dialog_Premium_Voices_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_premium_voices_sub = /** @type {((inputs?: Dialog_Premium_Voices_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Premium_Voices_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_premium_voices_sub(inputs)
	return en_dialog_premium_voices_sub(inputs)
});